<template>
    <el-dialog
        class="add-area-dialog"
        :visible.sync="visible"
        :title="$t('Reception.Fourth.new_area')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="90px"
            label-suffix=":">
            <el-form-item prop="storeId" :label="$t('Common.store')">
                <el-select
                    class="pr-2 reception-store"
                    v-model="form.storeId"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="`${index}-${item.id}`"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="name" :label="$t('Reception.Fourth.area_name')">
                <el-input
                    type="text"
                    v-model="form.areaName"
                    :placeholder="$t('Reception.Fourth.area_name_placeholder')">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.cancel') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Common.submit') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                storeId: null,
                areaName: '',
            },
            rules: {
                storeId: { type: 'number', required: true },
                areaName: {
                    type: 'string',
                    required: true,
                    message: this.$t('Reception.Fourth.area_name_placeholder'),
                },
            },
            stores: [],
            type: null,
            id: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(storeId, name, id, type) {
            this.form = {
                storeId: storeId,
                areaName: name,
            };
            if (this.form.areaName) this.form.areaName = this.form.areaName.split(" ")[0];
            this.type = type;
            this.id = id;
            this.fetchStore();
            this.visible = true;
        },
        fetchStore() {
            // 门店
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                if (this.type === 'add') this.postData();
                else this.putData();
            });
        },
        postData() {
            API.post('area', this.form).then(() => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('fetchLocker');
                this.visible = false;
            });
        },
        putData() {
            API.put(`area/${this.id}`, this.form).then(() => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('fetchLocker');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.add-area-dialog {
    .el-dialog {
        width: 430px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .reception-store {
        width: 100%;
    }
}
</style>
